





import { Component, Vue, Prop } from 'vue-property-decorator';
import { LazyHydrate } from '@jtnews/shared/ui';

@Component({
  name: 'Smi2VideoBlock',
  components: {
    LazyHydrate
  }
})
export default class Smi2VideoBlock extends Vue {
  @Prop({
    type: String,
    default: ''
  })
  content: string;
}
